.root {
  flex-grow: 0;
  flex-shrink: 0;
  width: 280px;
  padding: 0.5rem;
  overflow: hidden;
  color: var(--on-surface);
  background-color: var(--surface);
}

.text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @supports (-webkit-line-clamp: 2) {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: initial;
  }
}
